<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: Main OBC template for LogicFlow — delegates to full or side view based on uiMode.
-->
@if (initialized && dto) {

    @if (uiMode == 'side') {
        <mvs-lg-logic-flow-object-component-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></mvs-lg-logic-flow-object-component-side>
    } @else {
        <mvs-lg-logic-flow-object-component-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
                (onBreadcrumbItems)="handleBreadcrumbItems($event)"
        ></mvs-lg-logic-flow-object-component-full>
    }
}
